"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", function () {
        const mainSliderElement = document.getElementById(
            "main-nivelamento-splide"
        );
        const navSliderElement = document.getElementById(
            "nivelamento-nav-splide"
        );
        if (mainSliderElement) {
            const mainSplide = new Splide(mainSliderElement, {
                type: "slide",
                rewind: true,
                autoplay: true,
                interval: 8000,
                speed: 1200,
                pauseOnHover: true,
                arrows: false,
                pagination: false,
                gap: "1rem",
                breakpoints: {
                    1024: {
                        pagination: true,
                    },
                },
            });

            const navSplide = new Splide(navSliderElement, {
                isNavigation: true,
                gap: 71,
                rewind: true,
                pagination: false,
                arrows: false,
                perPage: 4,
                breakpoints: {
                    1200: { perPage: 3 },
                    992: { perPage: 2 },
                    768: { perPage: 1 },
                },
            });

            const progressBars =
                navSliderElement.querySelectorAll(".progress-bar");

            console.log(progressBars);

            // 2. Quando o autoplay está tocando, atualiza a barra do slide ATIVO
            mainSplide.on("autoplay:playing", (rate) => {
                // Encontra o índice do slide ativo no slider de navegação
                const activeIndex = navSplide.index;
                // Atualiza a largura da barra correspondente
                if (progressBars[activeIndex]) {
                    progressBars[activeIndex].style.width = `${rate * 100}%`;
                }
            });

            // 3. Quando o slide principal começa a se mover, reseta TODAS as barras
            mainSplide.on("move", () => {
                progressBars.forEach((bar) => {
                    bar.style.width = "0%";
                });
            });

            // Sincroniza os dois sliders
            mainSplide.sync(navSplide);

            // Inicia ambos
            mainSplide.mount();
            navSplide.mount();
        }
    });
}
